
import React from "react";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IHostBlogArticle } from "../../../../../services";

export interface BlogCardProps {
    category?: string;
    article: IHostBlogArticle;
    onSelect: (a: IHostBlogArticle) => void;
}

function BlogCard({ article: a, category, onSelect }: BlogCardProps) {
    return (<button className={styles["blog-card"]} onClick={() => onSelect(a)}>
        <span className={styles["tag"]}>[ {category || Utils.fineDateShort(new Date(a.updated_at))} ]</span>
        <span className={styles["blog-img"]}>
            {a.extra_data?.featured_image ? (<img src={a.extra_data.featured_image} alt={a.title} loading="lazy" />) : (<span className={styles["img-ph"]} />)}
        </span>
        <span className={styles["blog-title"]}>{a.title}</span>
    </button>);
}

export default BlogCard;
